import PropTypes from 'prop-types';
import styles from './styles.module.scss';
import TrackInfoScroller from '@/components/component-library/PlayerBar/TrackInfoScroller';
import { SMALL } from '@/config/assets';
import SquareImage from '@/components/component-library/Image/KeakieImageSquare';
import PlayRoundedIcon from '@/components/component-library/Icon/types/PlayRounded';
import PauseRoundedIcon from '@/components/component-library/Icon/types/PauseRounded';
import CaretIcon from '@/components/component-library/Icon/types/Caret';
import { classes } from '@/helpers/styling';

const AUTO_SCROLLER_PROPS = { infiniteScroll: true };

const PlayerBarSmall = ({
  assets,
  className,
  episodeId,
  episodeNumber,
  episodeTitle,
  onClickPlayPause,
  paused,
  showId,
  showTitle,
  progressPercentage,
  disablePlayPause
}) => {
  return (
    <>
      <div className={ classes(styles.playerBarSmall, className) }>
        <div className={ styles.playerBackground }>
          <SquareImage
            assetSize={ SMALL }
            assetsObj={ assets }
            className={ styles.showImage }
            hasBorderRadius
            key={ episodeId }
          />
        </div>
        <div className={ styles.playerContent }>
          <div className={ styles.trackInfo }>
            <div className={ classes(styles.showImageWrapper, { [styles.isVisible]: episodeId }) }>
              <SquareImage
                assetSize={ SMALL }
                assetsObj={ assets }
                hasBorderRadius
                key={ episodeId }
              />
            </div>
            <TrackInfoScroller
              autoScrollerProps={ AUTO_SCROLLER_PROPS }
              channelId={ showId }
              channelTitle={ showTitle }
              className={ styles.trackAutoScroller }
              disableClicks
              disableGradients
              disableLibraryButton
              episodeNumber={ episodeNumber }
              episodeTitle={ episodeTitle }
            />
          </div>
          <div
            className={ classes(styles.playButton, { [styles.isDisabled]: disablePlayPause }) }
            onClick={ disablePlayPause ? undefined : onClickPlayPause }
          >
            { paused && <PlayRoundedIcon /> }
            { !paused && <PauseRoundedIcon /> }
          </div>
          <div
            className={ styles.caretIcon }
          >
            <CaretIcon />
          </div>
        </div>
      </div>
      <div className={ styles.progressBar }>
        <div className={ styles.progressBarSeek } style={ { width: `${ progressPercentage * 100 }%` } } />
      </div>
    </>
  );
};

PlayerBarSmall.propTypes = {
  progressPercentage: PropTypes.number,
  assets: PropTypes.object,
  episodeId: PropTypes.string,
  episodeNumber: PropTypes.number,
  episodeTitle: PropTypes.string,
  onClickPlayPause: PropTypes.func.isRequired,
  paused: PropTypes.bool,
  showId: PropTypes.string,
  showTitle: PropTypes.string,
  className: PropTypes.string,
  disablePlayPause: PropTypes.bool
};

PlayerBarSmall.defaultProps = {
  assets: null,
  episodeId: '',
  episodeNumber: null,
  episodeTitle: '',
  paused: true,
  showId: '',
  showTitle: '',
  progressPercentage: 0,
  className: '',
  disablePlayPause: false
};

export default PlayerBarSmall;